import { render } from "./LandingNavMenu.vue?vue&type=template&id=032b005e"
import script from "./LandingNavMenu.vue?vue&type=script&lang=js"
export * from "./LandingNavMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__